<script lang="ts">
    let questions = [{
        "number": "01",
        "question": "How to earn LIS?",
        "answer": "LIS can be earned by completing daily tasks, achievements, or opening capsules in our games (Crypto Cats/Crypto Dragons). You can also win LIS in our contests and tournaments that we run on our social medias.<br><br><a href='https://twitter.com/realisnetwork' target='_blank'>Twitter</a>, <a href='https://t.me/RealisANN' target='_blank'>Telegram</a>",
        "visible": false
    }, {
        "number": "02",
        "question": "Is there an IOS version?",
        "answer": "Unfortunately there is no IOS version yet, but there will be games for the IOS in the future. We talk about all the innovations in our social networks. Follow us and be the first to know about it.<br><br><a href='https://twitter.com/realisnetwork' target='_blank'>Twitter</a>, <a href='https://t.me/RealisANN' target='_blank'>Telegram</a>",
        "visible": false
    }, {
        "number": "03",
        "question": "I'm unable to complete low level achievements, how to complete them?",
        "answer": "You need to enable \"Show Cats/Dragons\" option inside of the game settings.",
        "visible": false
    }, {
        "number": "04",
        "question": "Can I earn LIS from Legends of Listeria?",
        "answer": "Listeria is in its testing period right now and all LIS there are on testnet. After the release of Legends of Listeria, all LIS will move to the main wallet.",
        "visible": false
    }, {
        "number": "05",
        "question": "How to play Bingo?",
        "answer": "Bingo can be played by obtaining bingo cards from the capsules, you can get rewards for claiming row/column or filling a full board to claim a JACKPOT! Bingo can be played on Crypto Cats or Crypto Dragons.",
        "visible": false
    }, {
        "number": "06",
        "question": "My automerge stopped working after update...",
        "answer": "Please go to the game settings and enable your auto merge again. ",
        "visible": false
    }];
</script>

<section class="questions">
    <div class="container">
        <div class="list">
            {#each questions as { number, question, answer, visible }, i}
                <div class="item" class:active={visible} on:click={() => {visible = !visible}}>
                    <div class="question">
                        <div class="number">{number}</div>
                        {question}
                        <div class="toggle">
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <div class="answer">{@html answer}</div>
                </div>
            {/each}
        </div>
    </div>
</section>

<style>
    .item {
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.05);
        padding: 50px 140px 50px 145px;
        position: relative;
        margin-bottom: 10px;
        cursor: pointer;
    }

    .question {
        font-size: 30px;
        font-family: 'Anton', sans-serif;
        color: white;
        line-height: 1.5;
        display: flex;
        user-select: none;
    }

    .number {
        color: #504944;
        font-size: 50px;
        letter-spacing: 0.04em;
        font-family: 'Anton', sans-serif;
        text-transform: uppercase;
        position: absolute;
        line-height: 1;
        left: 50px;
    }

    .answer {
        display: none;
        font-size: 16px;
        line-height: 1.5;
        color: #A0AEC0;
        margin-top: 20px;
    }

    .answer :global(a) {
        color: #A0AEC0;
        transition: .25s;
    }

    .answer :global(a:hover) {
        color: white;
    }

    .item.active .answer {
        display: block;
    }

    .toggle {
        width: 40px;
        height: 40px;
        background: #0B1019;
        position: absolute;
        right: 50px;
        top: 50px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: .25s;
    }

    .toggle span {
        width: 14px;
        height: 2px;
        background: white;
        display: block;
        transition: .25s;
    }

    .toggle span:last-child {
        transform: rotate(90deg);
        position: absolute;
    }

    .item.active .toggle {
        background: white;
    }

    .item.active .toggle span:first-child {
        transform: rotate(45deg);
        background: #282D39;
    }

    .item.active .toggle span:last-child {
        transform: rotate(135deg);
        background: #282D39;
    }

    @media(max-width: 1199px) {
        .item {
            padding: 40px 130px 40px 130px;
        }

        .number {
            left: 40px;
        }

        .toggle {
            right: 40px;
            top: 40px;
        }
    }

    @media(max-width: 991px) {
        .question {
            font-size: 26px;
            line-height: 36px;
        }

        .number {
            line-height: 50px;
            margin-top: -5px;
        }
    }

    @media(max-width: 767px) {
        .item {
            padding: 20px 40px 20px 60px;
        }

        .number {
            font-size: 30px;
            line-height: 1;
            margin: 0;
            left: 20px;
        }

        .question {
            font-size: 20px;
            line-height: 1.5;
        }

        .toggle {
            right: 10px;
            top: 25px;
            width: 20px;
            height: 20px;
        }

        .answer {
            font-size: 12px;
            line-height: 1.5;
            margin-top: 15px;
        }
    }
</style>
